import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import FlagIcon from '@mui/icons-material/Flag';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';
import { useAbility } from '../../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../../constants/permissions';

const configCards = [
  {
    id: 'meeting-types',
    title: 'Meeting Types',
    description: 'Configure meeting types like Weekly 1:1, Quarterly Review, Career Discussion',
    icon: <EventIcon />,
    path: '/meetings-configuration/meeting-types',
    customIconStyle: {
      backgroundColor: '#2196F3',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.MEETING_TYPE
    }
  },
  {
    id: 'attendee-types',
    title: 'Attendee Types',
    description: 'Configure attendee types like Owner, Mandatory, Optional',
    icon: <PeopleIcon />,
    path: '/meetings-configuration/attendee-types',
    customIconStyle: {
      backgroundColor: '#4CAF50',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.MEETING_ATTENDEE_TYPE
    }
  },
  {
    id: 'meeting-statuses',
    title: 'Meeting Statuses',
    description: 'Configure meeting statuses like Draft, Scheduled, Completed, Cancelled',
    icon: <FlagIcon />,
    path: '/meetings-configuration/meeting-statuses',
    customIconStyle: {
      backgroundColor: '#FF9800',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.MEETING_STATUS
    }
  },
  {
    id: 'talking-points',
    title: 'Talking Points',
    description: 'Configure system talking points and questions for meetings',
    icon: <QuestionAnswerIcon />,
    path: '/meetings-configuration/talking-points',
    customIconStyle: {
      backgroundColor: '#9C27B0',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.MEETING_TALKING_POINT
    }
  },
  {
    id: 'relation-types',
    title: 'Meeting Relation Types',
    description: 'Configure relation types for linking meetings to goals, actions, and feedback',
    icon: <LinkIcon />,
    path: '/meetings-configuration/relation-types',
    customIconStyle: {
      backgroundColor: '#00BCD4',
    },
    permission: {
      action: ACTIONS.MANAGE,
      subject: SUBJECTS.MEETING_RELATION_TYPE
    }
  }
];

const MeetingsConfiguration = () => {
  const navigate = useNavigate();
  const ability = useAbility();

  const visibleCards = configCards.filter(card => {
    if (!card.permission) {
      return true;
    }
    return ability.can(card.permission.action, card.permission.subject);
  });

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Home
          </BackButton>
          <Title>Meetings Configuration</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" paragraph>
            Select a configuration option to manage meeting settings
          </Typography>

          <Grid container spacing={3}>
            {visibleCards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle
                      }
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default MeetingsConfiguration;
